import { useRequest } from "@certn/api";
import { BasicButton, DangerButton, Modal } from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  showToast,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface CancelRescreenModalProps {
  onClose: () => void;
  isOpen: boolean;
  caseId: string;
  refreshData: () => void;
}
export function CancelRescreenModal({
  onClose,
  isOpen,
  caseId,
  refreshData,
}: CancelRescreenModalProps) {
  const { t } = useTranslation();
  const request = useRequest();

  async function submitCancelRescreen(): Promise<void> {
    await request(
      `/api/internal/client-portal/case/${caseId}/cancel-rescreen/`,
      {
        method: "POST",
      }
    );
    refreshData();
    onClose();
    showToast(t("Rescreening has been cancelled"));
  }

  function handleSubmit() {
    submitCancelRescreen();
  }
  return (
    <Modal testID="cancel-rescreen-modal" isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Cancel rescreening")}</DialogHeader>
        <DialogContent>
          {t("Are you sure you want to cancel rescreening?")}
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="close-cancel-rescreen">
            {t("Close")}
          </BasicButton>
          <DangerButton onPress={handleSubmit} testID="save-cancel-rescreen">
            {t("Cancel rescreening")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
